import {
  CREATE_SUPPORT_TICKET,
  CREATE_SUPPORT_TICKET_SUCCESS,
  CREATE_SUPPORT_TICKET_FAILURE,
  GET_SUPPORT_TICKETS,
  GET_SUPPORT_TICKETS_SUCCESS,
  GET_SUPPORT_TICKETS_FAILURE,
} from "../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  tickets: [],
  error: null,
};

const supportTicketReducer = (state = INIT_STATE, action) => {
  switch (action?.type) {
    case CREATE_SUPPORT_TICKET:
      return { ...state, loading: true, error: null };
    case CREATE_SUPPORT_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: [action?.payload, ...state.tickets],
        error: null,
      };
    case CREATE_SUPPORT_TICKET_FAILURE:
      return { ...state, loading: false, error: "Failed to create ticket" };
    case GET_SUPPORT_TICKETS:
      return { ...state, loading: true, error: null };
    case GET_SUPPORT_TICKETS_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: action?.payload,
        error: null,
      };
    case GET_SUPPORT_TICKETS_FAILURE:
      return { ...state, loading: false, error: "Failed to fetch tickets" };
    default:
      return state;
  }
};

export default supportTicketReducer;